import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ef4b3e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reward-title" }
const _hoisted_2 = { class: "reward-content" }
const _hoisted_3 = { class: "reward-date" }
const _hoisted_4 = { class: "reward-total" }
const _hoisted_5 = { class: "reward-info-sum" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "本月通告數量", -1))
const _hoisted_7 = { class: "reward-info-details" }
const _hoisted_8 = { class: "reward-info-detail" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "實體活動", -1))
const _hoisted_10 = { class: "reward-info-detail" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "業配", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["reward", { 'reward--expand': _ctx.expand }])
    }, [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.title), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.reward.from) + " ~ " + _toDisplayString(_ctx.reward.to), 1),
        _createElementVNode("div", _hoisted_4, " $ " + _toDisplayString(_ctx.reward.totalReward.toLocaleString()), 1)
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["reward-info", { 'reward-info--expand': _ctx.expand }])
    }, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("span", null, _toDisplayString(_ctx.reward.totalJobAmount.toLocaleString()), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("span", null, _toDisplayString(_ctx.reward.entityJobAmount.toLocaleString()), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("span", null, _toDisplayString(_ctx.reward.adsJobAmount.toLocaleString()), 1)
        ])
      ])
    ], 2)
  ], 64))
}